import ReactCompareImage from "react-compare-image";
import { useTranslation } from "react-i18next";

const ImageSlider = () => {
  const { t } = useTranslation();
  return (
    <div className="container my-5 shadow p-3 mb-5 bg-body rounded-4 image-slider" style={{position: 'relative'}}>
      <div className="bubble-img-wrapper">
        <img src="images/p6.webp" alt="Product" className="bubble-img" />
      </div>
      <ReactCompareImage
        leftImage="/images/before.webp"
        rightImage="/images/after.webp"
        rightImageLabel={t("rightImageLabel")}
        leftImageLabel={t("leftImageLabel")}
        rightImageCss={{ borderRadius: "15px" }}
        leftImageCss={{ borderRadius: "15px" }}
        handle={
          <div className="handle-img">
            <div className="handle-img-left"></div>
            <div className="handle-img-right"></div>
          </div>
        }
      />
    </div>
  );
};

export default ImageSlider;
